import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';

import { Async } from '../../../components/AsyncProvider';
import { Loading } from '../../../components/Loading/index';
import { IApplicationState } from '../../../store/models';
import { getAgencyAction } from '../store/actions';
import { AboutUs } from './AboutUs';
import { Services } from './Services';
import { TeamMembers } from './Team';

export const AgencyPage: React.FC = () => {
    const dispatch = useDispatch();

    React.useEffect(
        () => {
            dispatch(getAgencyAction());
        },
        [dispatch]
    );
    const agencyBranch = useSelector((state: IApplicationState) => state.agency);

    return (
        <>
            <Helmet>
                <title>SCOUT - Agency</title>
            </Helmet>
            <Async
                branch={agencyBranch}
                deps={[agencyBranch]}
                successRender={(data) => {
                    const { page_content, services, team_members } = data;
                    return (
                        <>
                            <AboutUs content={page_content} />
                            <Services content={services} />
                            {
                                team_members &&
                                Boolean(team_members.length) &&
                                <TeamMembers content={team_members} />
                            }
                        </>
                    );
                }}
                loadingRender={() => <Loading />}
            />
        </>
    );
};
